<template>
  <el-menu
    class="el-menu-vertical-demo"
    @open="handleOpen"
    @close="handleClose"
    background-color="#2E3A4D"
    text-color="#B7BDC6"
    active-text-color="#0084ea"
    :collapse-transition="false"
    :router="false"
  >
    <div v-for="(itemz, indexs) in bannnerdata" :key="indexs">
      <!-- 一级菜单 assets/sidebar-icon/icon11.png -->
      <el-menu-item
        :index="itemz.name"
        :class="isColor(itemz)"
        @click="tobannav(itemz.meta.name, itemz.name)"
      >
        <img
          :src="require(`@/assets/sidebar-icon/icon${indexs+1}${indexs+1}.png`)"
          alt=""
          class="img_box"
        />
        <span>{{ itemz.meta.name }}</span>
      </el-menu-item>
    </div>
  </el-menu>
</template>

<script>
import menuList from "@/router/routerList";
export default {
  data() {
    return {
      bannnerdata: [], // 路由的数组
      islect: "", //默认选中
      isActiveTitle: [],
      fullpatharr: [],
    };
  },
  props: {
    issleectname: {
      type: String,
      default: "",
    },
  },
  methods: {
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    tobannav(titlename, name) {
      this.islect = name;
      if (this.isActiveTitle.indexOf(titlename) === -1) {
        this.$root.$Navbottom(titlename, name);
        this.isActiveTitle.push(titlename);
      }
      if (this.$route.name != name) {
        this.$router.push({ name: name });
      }
    },
  },
  watch: {
    issleectname(newstr, oldstr) {
      this.islect = newstr;
    },
  },
  computed: {
    isColor() {
      return function (row) {
        // console.log(this.$route.name, "================>>>", row.name);
        // console.log(  this.$route.name.indexOf(row.name) !== -1);
        if ((this.$route.name.indexOf(row.name) !== -1) == true) {
          return "isrouternav";
        }
        return;
        // return "isrouternav";
        if (this.$route.meta.name == row.meta.name) {
          return "isrouternav";
        } else {
          return "";
        }
      };
    },
  },
  created() {
    // isSuper == 1 的时候是超级管理员
    // let id = JSON.parse(sessionStorage.getItem("token")).isSuper;
    let newarr = JSON.parse(JSON.stringify(menuList));
    this.bannnerdata = newarr;
    // this.bannnerdata = menuList;
    this.fullpatharr = this.bannnerdata.map((item) => {
      return item.Training;
    });
    localStorage.setItem("routername", JSON.stringify(this.fullpatharr));
  },
};
</script>

<style lang="scss" scoped>
i {
  color: #fff !important;
  margin-right: 8px;
}
.el-menu {
  border: none;
  height: 100%;
}
::v-deep .el-menu-item {
  &:hover {
    background: #ebecf1 !important;
  }
  .img_box {
    width: 24px;
    height: 24px;
    display: inline-block;
    margin-right: 28px;
  }
}
::v-deep .el-submenu__title {
  height: 60px;
  align-items: center;
  display: flex;
  align-items: center;
  .img_box {
    width: 24px;
    height: 24px;
    display: inline-block;
    margin-right: 28px;
  }
  &:hover {
    background: #ebecf1 !important;
  }
}
::v-deep.el-menu-item.is-active {
  // color: #0084ea;
  // background-color: #000000 !important;
  height: 60px;
}
::v-deep .el-menu-item {
  height: 60px !important;
}
::v-deep .el-menu--inline {
  .el-menu-item {
    padding-left: 70px !important;
  }
}
.isrouternav {
  // background: red !important;
  background: #000000 !important;
  color: #0084ea !important;
}
::v-deep .el-menu-item {
  color: #777f8f;
}
</style>
